import { styled } from '@mui/material';

import { Button } from '../../../Button';

export const DatePickerActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const DatePickerActionsButton = styled(Button)(() => ({
  minWidth: 128,
  height: 36,
}));
